import { AuthConfig } from 'angular-oauth2-oidc';

import { environment } from '../../environments/environment';

export const authPasswordFlowConfig: AuthConfig = {
	sessionChecksEnabled: false,
	issuer: 'https://oauth.go-suite.com/',
	clientId: 'vanessa',
	dummyClientSecret: 'top_secret',
	scope: 'openid profile offline_access xena urania',
	showDebugInformation: !environment.production,
	oidc: false,
	requireHttps: true,
	requestAccessToken: true,
};



// WEBPACK FOOTER //
// ./src/app/login/auth-password-flow.config.ts